<template>
    <div class="row date-filter pad-top">
        <div class="col-12">
            <div class="row actions">
                <div class="col-6 action">
                    <DatePicker :language="Storage.language" v-model="Storage.selectedMonthFrom" :minimumView="'month'" :maximumView="'month'" 
                                :format="DatePickerFormat" :disabled="disabledDates"></DatePicker>
                </div>
                <div class="col-6 action">
                    <DatePicker :language="Storage.language" v-model="Storage.selectedMonthTo" :minimumView="'month'" :maximumView="'month'"
                                :format="DatePickerFormat" :disabled="disabledDates">></DatePicker>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row actions">
                <div class="col-6 action">
                    <button class="btn btn-info reset" @click="this.reset" :disabled="disabled"><i
                            class="fa fa-trash"></i>
                        {{ $t('filters.reset') }}
                    </button>
                </div>
                <div class="col-6 action">
                    <dropdown :disabled="disabled">
                        <template slot="button" :disabled="disabled"><i class="fa fa-clock-o"></i> {{ $t('filters.period') }}</template>
                        <div slot="dropdown-menu" class="dropdown-menu" :disabled="disabled">
                            <a class="dropdown-item" :disabled="disabled"
                               @click="yesterday">{{ $t('filters.yesterday') }}</a>
                            <a class="dropdown-item" :disabled="disabled" @click="week">{{ $t('filters.week') }}</a>
                            <a class="dropdown-item" :disabled="disabled"
                               @click="thisMonth">{{ $t('filters.this_month') }}</a>
                            <a class="dropdown-item" :disabled="disabled"
                               @click="lastMonth">{{ $t('filters.last_month') }}</a>
                        </div>
                    </dropdown>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import DatePicker from 'vuejs-datepicker'
  import Storage from '../../api/Storage'
  import { dropdown } from 'vue-strap'

  export default {
    props: {
      disabled: {
        type: Boolean,
        required: true
      }
    },
    name: 'MonthFilter',
    components: {
      DatePicker,
      dropdown
    },
    data () {
      return {
        Storage: Storage,
        DatePickerFormat: 'yyyy-MM',
        disabledDates: {
          to: new Date(2017, 7, 31)
        }
      }
    },
    methods: {
      yesterday () {
        let date = new Date()
        date.setDate(date.getDate() - 1)
        Storage.selectedMonthTo = Storage.selectedMonthFrom = date
      },
      getMaxDate (y, m) {
        if (m === 1) {
          return y % 4 || (!(y % 100) && y % 400) ? 28 : 29
        }
        return m === 3 || m === 5 || m === 8 || m === 10 ? 30 : 31
      },
      week () {
        let date = new Date()
        date.setDate(date.getMonth() - 1)
        Storage.selectedMonthFrom = date
        Storage.selectedMonthTo = new Date()
      },
      month () {
        let date = new Date()
        date.setMonth(date.getMonth() - 12)
        date.setDate(1)
        Storage.selectedMonthFrom = date

        date = new Date()
        date.setDate(1)
        Storage.selectedMonthTo = date
      },
      thisMonth () {
        let date = new Date()
        date.setDate(1)
        Storage.selectedDateFrom = date
        Storage.selectedDateTo = new Date()
      },
      lastMonth () {
        let date = new Date()
        date.setMonth(date.getMonth() - 1)
        date.setDate(1)
        Storage.selectedDateFrom = date

        date = new Date()
        date.setMonth(date.getMonth() - 1)
        date.setDate(this.getMaxDate(date.getYear(), date.getMonth()))
        Storage.selectedDateTo = date
      },
      reset () {
        this.month()
      }
    },
    mounted: function () {
      if (Storage.selectedMonthFrom === null) {
        this.reset()
      }
      this.$root.$on('filters_reset_all', () => {
        this.reset()
      })
    }
  }
</script>

<style>
.pad-top{
  padding-top:5px; 
}
</style>



// WEBPACK FOOTER //
// MonthFilter.vue?98c501d6